import { Autocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContactSearchAutocomplete = styled(Autocomplete)({
  width: '100%',
  height: 120,
}) as typeof Autocomplete;
